import { render, staticRenderFns } from "./orders-statistics.vue?vue&type=template&id=42657e0a&"
import script from "./orders-statistics.vue.ts?vue&type=script&lang=ts&"
export * from "./orders-statistics.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports